exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nh2[data-v-4bb831b3] {\r\n  margin-top: 12px !important;\r\n  font-weight: normal;\n}\n.divP[data-v-4bb831b3] {\r\n  padding-top: 15px;\n}\n.aclaracion[data-v-4bb831b3] {\r\n  margin-top: 15px;\r\n  font-style: italic;\n}\n.btnPlantilla[data-v-4bb831b3] {\r\n  padding-right: 20px;\n}\r\n", ""]);

// exports
